"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmobilityCaseAction = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_validator_1 = require("class-validator");
const CaseActionType_1 = require("./enums/CaseActionType");
class EmobilityCaseAction extends base_models_1.Serializable {
}
exports.EmobilityCaseAction = EmobilityCaseAction;
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'the case action type', example: CaseActionType_1.CaseActionType.CallbackCustomer }),
    (0, class_validator_1.IsEnum)(CaseActionType_1.CaseActionType),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], EmobilityCaseAction.prototype, "action", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'the action date', example: new Date('2023-05-25').toISOString() }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Date)
], EmobilityCaseAction.prototype, "actionDate", void 0);
tslib_1.__decorate([
    (0, base_models_1.Docs)({ description: 'the assignee', example: 'Gerard Eit' }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], EmobilityCaseAction.prototype, "operator", void 0);
